import React from 'react';
import SiteHeader from './components/SiteHeader';
import BusinessIntro from './components/BusinessIntro';
import ProductSection from './components/ProductSection';
import WholesaleSection from './components/WholesaleSection';
import CustomerReviews from './components/CustomerReviews';
import ContactInfo from './components/ContactInfo';

// Meta tags và JSON-LD nằm tĩnh trong public/index.html để bot đọc được không cần chạy JS.
function App() {
  return (
    <>
      <SiteHeader />
      <main>
        <BusinessIntro />
        <ProductSection />
        <WholesaleSection />
        <CustomerReviews />
        <ContactInfo />
      </main>
    </>
  );
}

export default App;
